export default {"src":"/_next/static/media/parkableLogo.c0fc9f14.svg","height":36,"width":164,"blurWidth":0,"blurHeight":0};